import React, { useState, useEffect } from "react";
import { FontSize } from "config/font";
import { TextInputWithLabel } from "web-apps/company/components/general/textInput/textInput.component";
import { normalizeNumber } from "web-apps/company/components/common/number.normalize.logic";
import { SettingsSection } from "./settingSection.component";

export const PercentageInput: React.FC<{
  value: number;
  onChange: (v: number) => void;
  min: number;
  max: number;
  title: string;
  info: string;
}> = ({ value, onChange, min, max, title, info }) => {
  const [str, setStr] = useState(value.toString());

  useEffect(() => {
    setStr(value.toString());
  }, [value]);

  const commit = () => {
    const n = normalizeNumber(str);
    const v =
      n == null ? min : Math.min(max, Math.max(min, Math.round(n * 100) / 100));
    setStr(v.toFixed(2));
    onChange(v);
  };

  return (
    <SettingsSection title={title} info={info}>
      <TextInputWithLabel
        label={title}
        value={str}
        fontSize={FontSize.Standard}
        maxLength={6}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setStr(e.target.value)
        }
        onBlur={commit}
        onKeyDown={(e) => e.key === "Enter" && commit()}
      />
    </SettingsSection>
  );
};
